export const v2UiEnabled = () => process.env.REACT_APP_DMP_PRICING_V2_ENABLED === 'true';

// 候選預設不開售；須明確開啟 UI 與付款旗標才允許啟動新付款；原訂單恢復交由後端裁決。
export const v2CheckoutEnabled = () => v2UiEnabled() && process.env.REACT_APP_DMP_CHECKOUT_V2_ENABLED === 'true';

// 僅允許已有正式 mapping 的商品；實際是否可購買仍以伺服器資格與可用性檢核為準。
// Personal e-Cert、兩種 AI 草擬及非會員信用報告不透過新版 Checkout 收款。
const releasedProducts = new Set([
  'individual', 'sme_firm', 'barrister', 'law_firm',
  'blockchain_10_registrations', 'translation_40_uploads',
  'video_conferencing_2400_minutes', 'transcription_1000_minutes', 'standard_esign_120_envelopes',
  'cross_border_esign', 'hkpost_ecert_organization', 'lei_1_year',
  'prc_credit_report_1', 'prc_credit_report_5', 'prc_credit_report_10', 'storage_100gb', 'storage_25gb',
  'top_up_storage_individual_25gb', 'top_up_storage_company_100gb', 'top_up_transcription_600_minutes',
  'top_up_translation_10_uploads', 'top_up_video_conferencing_600_minutes',
  'top_up_standard_esign_20_envelopes', 'top_up_blockchain_1_registration',
]);
export const v2UnavailableFeature = (feature: string) => ['hkpost_ecert_personal', 'ai_contract_drafting'].includes(feature);
export const v2ProductScopeAllowed = (product: string) => releasedProducts.has(product);
export const v2ProductCheckoutEnabled = (product: string) => v2CheckoutEnabled() && v2ProductScopeAllowed(product);
